import { render, staticRenderFns } from "./FileAgent.vue?vue&type=template&id=47d80c9e"
import script from "./FileAgent.vue?vue&type=script&lang=js"
export * from "./FileAgent.vue?vue&type=script&lang=js"
import style0 from "./FileAgent.vue?vue&type=style&index=0&id=47d80c9e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d80c9e')) {
      api.createRecord('47d80c9e', component.options)
    } else {
      api.reload('47d80c9e', component.options)
    }
    module.hot.accept("./FileAgent.vue?vue&type=template&id=47d80c9e", function () {
      api.rerender('47d80c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/FileAgent.vue"
export default component.exports